// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__11w91","right":"styles_right__3Og-A"};